import { NavLink } from "react-router-dom";
import "../style/articleLayout.css";

export default function Breadcrumbs({ items = [] }) {
  if (!items.length) {
    return null;
  }

  return (
    <nav className="article-breadcrumbs" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={item.to || item.label}>
            {isLast ? (
              <strong>{item.label}</strong>
            ) : (
              <NavLink to={item.to}>{item.label}</NavLink>
            )}
            {!isLast && <i>/</i>}
          </span>
        );
      })}
    </nav>
  );
}
